import Conversation from "../model/Conversation";

export default class ConversationFinishedEvent {
    /**
     * @constructor
     * @param {Conversation} conversation 
     */
    constructor(type, conversation) {
        this._type = type;

        this._conversation = conversation;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }
}

ConversationFinishedEvent.PERFORM = "ConversationFinishedEvent.PERFORM";